import axios from 'axios';

// Use backend base URL from environment variable
const API_BASE = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8080';

// Get auth token from localStorage
const getAuthToken = () => {
  return localStorage.getItem('token') || sessionStorage.getItem('token');
};

// Get pending payment verifications
export const getPendingVerifications = async () => {
  try {
    const response = await axios.get(
      `${API_BASE}/api/payment-verification/pending`,
      {
        headers: {
          'Authorization': `Bearer ${getAuthToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Gagal mengambil data verifikasi' };
  }
};

// Get approved bookings awaiting payment
export const getApprovedBookings = async () => {
  try {
    const response = await axios.get(
      `${API_BASE}/api/payment-verification/approved-bookings`,
      {
        headers: {
          'Authorization': `Bearer ${getAuthToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Gagal mengambil data booking' };
  }
};

// Get bookings awaiting pelunasan (DP paid but not fully paid)
export const getAwaitingPelunasan = async () => {
  try {
    const response = await axios.get(
      `${API_BASE}/api/payment-verification/awaiting-pelunasan`,
      {
        headers: {
          'Authorization': `Bearer ${getAuthToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Gagal mengambil data booking pelunasan' };
  }
};

// Upload payment proof
export const uploadPaymentProof = async (bookingId, formData) => {
  try {
    const response = await axios.post(
      `${API_BASE}/api/payment-verification/upload/${bookingId}`,
      formData,
      {
        headers: {
          'Authorization': `Bearer ${getAuthToken()}`,
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Gagal upload bukti pembayaran' };
  }
};

// Verify payment
export const verifyPayment = async (verificationId) => {
  try {
    const response = await axios.post(
      `${API_BASE}/api/payment-verification/verify/${verificationId}`,
      {},
      {
        headers: {
          'Authorization': `Bearer ${getAuthToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Gagal verifikasi pembayaran' };
  }
};

// Reject payment proof
export const rejectPaymentProof = async (verificationId, rejectionReason) => {
  try {
    const response = await axios.post(
      `${API_BASE}/api/payment-verification/reject/${verificationId}`,
      { rejection_reason: rejectionReason },
      {
        headers: {
          'Authorization': `Bearer ${getAuthToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Gagal reject bukti pembayaran' };
  }
};

// Get daily reconciliation report
export const getDailyReport = async (date = null) => {
  try {
    const url = date
      ? `${API_BASE}/api/reconciliation/daily-report/${date}`
      : `${API_BASE}/api/reconciliation/daily-report`;

    const response = await axios.get(url, {
      headers: {
        'Authorization': `Bearer ${getAuthToken()}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Gagal mengambil laporan rekonsiliasi' };
  }
};

// Get mismatch alerts
export const getMismatchAlerts = async () => {
  try {
    const response = await axios.get(
      `${API_BASE}/api/reconciliation/mismatch-alerts`,
      {
        headers: {
          'Authorization': `Bearer ${getAuthToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Gagal mengambil alert mismatch' };
  }
};

// Get audit trail
export const getAuditTrail = async (filters = {}) => {
  try {
    const response = await axios.get(
      `${API_BASE}/api/reconciliation/audit-trail`,
      {
        params: filters,
        headers: {
          'Authorization': `Bearer ${getAuthToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Gagal mengambil audit trail' };
  }
};
